module.exports = __webpack_public_path__ + "8c5e7162964e5a58c268c2fbdffc67e9.fbx";